import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

import Store from '../Store';


export default class GardenLighting {
 constructor() {
    this.sceneGraph = {
      type: 'group',
      id: 'garden-lamps',
      children: [
        {
          id: "lamp-1",
          type: 'model',
          modelUrl: "https://static.mused.org/garden_lamp_green_3.glb",
          position: [-0.8, 0.75, -0.37],
          scale: [0.016, 0.016, 0.016]
        },
        {
          id: "lamp-2",
          type: 'model',
          modelUrl: "https://static.mused.org/garden_lamp_green_1.glb",
          position: [-3.04, -0.31, 4.38],
          scale: [0.2, 0.2, 0.2]
        },
        {
          id: "lamp-3",
          type: 'model',
          modelUrl: "https://static.mused.org/garden_lamp_green_2.glb",
          position: [5.63, -0.533, 0.08],
          scale: [0.03, 0.03, 0.03]
        },
        {
          id: "lamp-4",
          type: 'model',
          modelUrl: "https://static.mused.org/garden_lamp_green_3.glb",
          position: [-2.86, -0.19, -2.19],
          scale: [0.026, 0.026, 0.026]
        }
      ]
    };
    this.lightsAndModels = []; // Array to hold point light references

    this.initScene();
  }

  initScene() {
    const { scene, debugMode } = Store.getState();

    const loader = new GLTFLoader();
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://static.mused.org/spaceshare/draco1.5.6/');
    loader.setDRACOLoader(dracoLoader);

    this.sceneGraph.children.forEach(item => {
      loader.load(item.modelUrl, gltf => {
        gltf.scene.position.set(...item.position);
        gltf.scene.scale.set(...item.scale);
        gltf.scene.visible = false;
        scene.add(gltf.scene);

        const pointLight = new THREE.PointLight(0xFFA500, 1, 100);
        pointLight.position.set(item.position[0], item.position[1] + 0.4, item.position[2]);
        pointLight.visible = false;
        scene.add(pointLight);

        // Add the model and point light to the array
        this.lightsAndModels.push({
          model: gltf.scene,
          light: pointLight
        });

        if (debugMode) {
            const sphereSize = 1;
            const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
            scene.add( pointLightHelper );
        }
      }, undefined, function (error) {
        console.error(`An error occurred while loading the model: ${item.id}`, error);
      });
    });
  }

  turnOn() {
    // Loop through all pairs and set both the model and light to be visible
    this.lightsAndModels.forEach(pair => {
      pair.model.visible = true;
      pair.light.visible = true;
    });
  }

  turnOff() {
    // Loop through all pairs and set both the model and light to be invisible
    this.lightsAndModels.forEach(pair => {
      pair.model.visible = false;
      pair.light.visible = false;
    });
    }
}